var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBnTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b5b3c956-4f13-487d-a800-4e86f263705a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .a84af4ab-5bfa-476a-a906-0f2d2a70c0e4 {\r\n        fill: #ccc;\r\n      }\r\n\r\n      .a452638a-5946-4576-8a83-1af3b382c8ca {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "a84af4ab-5bfa-476a-a906-0f2d2a70c0e4",
    width: 45,
    height: 45,
    rx: 7.101
  }), /*#__PURE__*/React.createElement("path", {
    className: "a452638a-5946-4576-8a83-1af3b382c8ca",
    d: "M5.723,33.067A19.653,19.653,0,0,0,35.879,16.458q0-.406-.016-.808c.393-.309,2.821-2.255,3.416-3.506a15.954,15.954,0,0,1-3.9,1.012h-.013l.011-.007c.177-.118,2.663-1.811,3-3.827a23.908,23.908,0,0,1-3.347,1.4c-.324.107-.662.213-1.011.311A6.9,6.9,0,0,0,22.267,17.3,20.77,20.77,0,0,1,8.114,10.147s-3.3,4.5,1.965,9.126A7.076,7.076,0,0,1,7.1,18.385a6.554,6.554,0,0,0,5.45,6.845,6.306,6.306,0,0,1-3.042.127,6.8,6.8,0,0,0,6.338,4.816A13.243,13.243,0,0,1,5.721,33.067Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnTwitter);
export default __webpack_public_path__ + "static/media/bnTwitter.28dd8c3f328e7034dda9963b81d74a7e.svg";
export { ForwardRef as ReactComponent };